// extracted by mini-css-extract-plugin
export default {"gradient-bg5":"toggleSwitch__gradient-bg5__DWiAp","toggleSwitch":"toggleSwitch__toggleSwitch__flYN4"};